export default class Money {
    static calculateTaxAmount(amount, taxRate) {
        return (amount * (taxRate / 100));
    }

    static calculateAmountIncludingTax(amount, taxRate) {
        return (amount * (taxRate / 100)) + amount;
    }

    static formatPrice(amount) {
        const formattedAmount = Number(amount).toFixed(2);

        return `€\xa0${formattedAmount}`;
    }
}